/**
 * Supported language codes
 */
export const LANGUAGE_CODES = ["ru", "uz", "en", "kz"] as const;
export type LanguageCode = string;

/**
 * Language metadata for display
 */
export const LANGUAGE_META: Record<
  LanguageCode,
  { name: string; flag: string; nativeName: string }
> = {
  ru: { name: "Russian", flag: "🇷🇺", nativeName: "Русский" },
  uz: { name: "Uzbek", flag: "🇺🇿", nativeName: "O'zbek" },
  en: { name: "English", flag: "🇬🇧", nativeName: "English" },
  kz: { name: "Kazakh", flag: "🇰🇿", nativeName: "Қазақ" },
};

/**
 * Field configuration for translations
 */
export interface TranslationFieldConfig {
  name: string;
  label: string;
  type: "input" | "textarea" | "richtext";
  placeholder?: string;
  required?: boolean;
  rows?: number;
}

/**
 * Translation data structure
 */
/**
 * Translation data structure
 */
export type TranslationData = Record<string, Record<string, string>>;

/**
 * Helper function to create empty translation data
 */
export function createEmptyTranslationData(): TranslationData {
  // Return empty object.
  // Translations will be initialized dynamically when user types in the form
  // or when existing data is loaded.
  return {};
}

/**
 * Helper function to validate translation data
 */
export function validateTranslationData(
  data: TranslationData,
  fields: TranslationFieldConfig[],
  requiredLanguages: string[] = ["ru"]
): Record<string, Record<string, string>> {
  const errors = {} as Record<LanguageCode, Record<string, string>>;

  for (const lang of requiredLanguages) {
    const langData = data[lang] ?? {};
    const langErrors: Record<string, string> = {};

    for (const field of fields) {
      if (field.required && !langData[field.name]?.trim()) {
        langErrors[field.name] = `${field.label} обязательно для заполнения`;
      }
    }

    if (Object.keys(langErrors).length > 0) {
      errors[lang] = langErrors;
    }
  }

  return errors;
}
